import { render, staticRenderFns } from "./DhmeWkbInspectionPlanRisks.vue?vue&type=template&id=5dd9ed23&scoped=true"
import script from "./DhmeWkbInspectionPlanRisks.vue?vue&type=script&lang=js"
export * from "./DhmeWkbInspectionPlanRisks.vue?vue&type=script&lang=js"
import style0 from "./DhmeWkbInspectionPlanRisks.vue?vue&type=style&index=0&id=5dd9ed23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9ed23",
  null
  
)

export default component.exports